import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { ADMIN_PATH } from "@/lib/adminPath";

function getVisitorId() {
  let id = localStorage.getItem("rm_visitor_id");
  if (!id) {
    id =
      (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("rm_visitor_id", id);
  }
  return id;
}

export default function VisitTracker() {
  const location = useLocation();
  const sid = useRef(getVisitorId());
  const adminPrefix = `/${ADMIN_PATH}`;

  // rejestracja wejścia przy każdej zmianie strony (poza panelem admina)
  useEffect(() => {
    if (location.pathname.startsWith(adminPrefix)) return;
    api
      .post("/track/visit", {
        session_id: sid.current,
        path: location.pathname,
        referrer: typeof document !== "undefined" ? document.referrer : "",
      })
      .catch(() => {});
  }, [location.pathname, adminPrefix]);

  // heartbeat co 30s — utrzymuje status "online"
  useEffect(() => {
    if (location.pathname.startsWith(adminPrefix)) return;
    const t = setInterval(() => {
      api.post("/track/heartbeat", { session_id: sid.current }).catch(() => {});
    }, 30000);
    return () => clearInterval(t);
  }, [location.pathname, adminPrefix]);

  return null;
}
